import {
  AutomationsPresentationV1Edge,
  AutomationsPresentationV1Node
} from 'Automations/automationEditor/types'
import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import { IntermediateNodeWithConditionalsAndOutputs } from '../presentationToConductorWorkflow/presentationToConductorWorkflow.types'

export const getUpstreamNodesWithOutputs = ({
  nodes,
  edges,
  targetNodeId,
  definitions
}: {
  nodes: AutomationsPresentationV1Node[]
  edges: AutomationsPresentationV1Edge[]
  targetNodeId: string
  definitions: ResolvedNodeDefinitions
}): IntermediateNodeWithConditionalsAndOutputs[] => {
  const nodeMap = new Map(nodes.map(n => [n.id, n]))

  const collectUpstreamIds = (
    currentId: string,
    visited: Set<string>
  ): string[] => {
    const sources = edges.reduce<string[]>((acc, edge) => {
      if (edge.target === currentId && !visited.has(edge.source)) {
        visited.add(edge.source)
        return [...acc, edge.source]
      }
      return acc
    }, [])

    return sources.reduce<string[]>(
      (acc, sourceId) => [...acc, ...collectUpstreamIds(sourceId, visited)],
      sources
    )
  }

  // Reverse to get topological order (start node first)
  const upstreamNodeIds = collectUpstreamIds(
    targetNodeId,
    new Set<string>()
  ).reverse()

  return upstreamNodeIds.reduce<IntermediateNodeWithConditionalsAndOutputs[]>(
    (acc, id) => {
      const node = nodeMap.get(id)
      if (!node?.type) return acc

      try {
        const definition = definitions[node.type as NodeType]
        return [
          ...acc,
          {
            node,
            branches: [],
            outputs: definition?.outputMapping?.(node.id) ?? {},
            conditionalProperties: {}
          }
        ]
      } catch {
        return acc
      }
    },
    []
  )
}
